/**
 * 為 CF Stream iframe URL 加上 query 參數（autoplay / muted / preload / poster 等）。
 * playback_url 可能已自帶 query string，所以用 URL 物件處理；解析失敗時回傳原值。
 *
 * @param {string} playbackUrl
 * @param {Object} options - 例如 { autoplay: true, muted: true, preload: 'auto', poster: '...' }
 * @returns {string}
 */
export const getStreamEmbedUrl = (playbackUrl, options = {}) => {
  if (!playbackUrl) return '';
  try {
    const url = new URL(playbackUrl);
    Object.entries(options).forEach(([key, value]) => {
      if (value === undefined || value === null || value === false || value === '') return;
      url.searchParams.set(key, value === true ? 'true' : String(value));
    });
    return url.toString();
  } catch {
    return playbackUrl;
  }
};
